import tosConsent from "./tnc/v1/consent.json";
import privacyConsent from "./privacy/v1/consent.json";

const LEGAL_CONSENT_BY_TYPE = {
  tos: tosConsent,
  privacy: privacyConsent,
};

/**
 * Local bundled legal consent JSON (mirrors S3 paths legal/tnc/v1/consent.json and legal/privacy/v1/consent.json).
 */
export function getLegalConsentConfig(documentType) {
  return LEGAL_CONSENT_BY_TYPE[documentType] ?? null;
}
